import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { Summary } from '../../model/summary'

const initialState: Summary = {
	lensometry: [],
	prescriptions: [],
	contactLenses: [],
	orders: [],
	chiefCompliant: [],
	diagnosis: [],
	medications: [],
}

export const slice = createSlice({
	name: 'summary',
	initialState,
	reducers: {
		_setSummary: (state, { payload }: PayloadAction<Summary>) => payload,
	},
})

export default slice.reducer
